import {GenericService} from '@/shared/xhttp';
import {Country} from '@/models';

export class CountryService extends GenericService<Country> {
}